
import {store} from "../store/store";
import axios from "axios";
import * as Constants from "./api.constants";
import {
    errorInitApp,
    resetAuthenticationData,
    resetAuthenticationSsoData, resetContentData,
    resetMobinauteData,
    resetRouteData
} from "../actions";
import {logout} from "../containers/NavBar/NavBar.functions"
import {cleanUrl, getQueryVariable, pushHistory, pushToDataLayer, urlrewriting} from "../helpers/Tools";
import localForage from "localforage";
import Cookies from "universal-cookie";
import {baseApiUrl} from "./api";
import {openItem} from "../containers/Home/Home.functions";

const cookies = new Cookies();

//getContent
export const fetchGetContent = async () => {
    try {
        let bodyFormData = new FormData();
        let state = store.getState().application;

        bodyFormData.set("deviceId", state.deviceId);
        bodyFormData.set("mobinauteId", "");
        bodyFormData.set("appId", state.getApp.id);

        return await axios({
            method: "post",
            url: baseApiUrl + Constants.WS_GET_CONTENT,
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then(function (response) {
                //handle success
                store.dispatch(resetAuthenticationSsoData())
                store.dispatch(resetAuthenticationData())
                store.dispatch(resetRouteData())
                store.dispatch(resetMobinauteData())

                response.data.loading = false;

                if(response.data.success){

                    let data_str = JSON.stringify(response.data);
                    data_str = data_str.replace("[%DEVICE_TOKEN]", store.getState().application.deviceToken.access_token);
                    response.data = JSON.parse(data_str);

                    return response.data;
                } else {
                    console.log(response.data)

                    store.dispatch(errorInitApp({info:"fetchGetContent", data: response}))

                    return null;
                }
            })
            .catch(function (response) {
                //handle error
                console.log(response);

                store.dispatch(errorInitApp({info:"fetchGetContent", data: response}))
            });
    } catch (e) {
        console.log(e);

        store.dispatch(errorInitApp({info:"fetchGetContent", data: e}))
    }
};

//GetAuthentication
export const fetchGetAuthentication = async (props) => {
    try {
        let state = store.getState().application;

        let appId = state.getApp.id;
        let deviceId = state.deviceId;
        let remember_me = state.remember_me;

        let login = props.login;
        let password = props.password;
        let eulaHaveBeenAccepted = props.eulaHaveBeenAccepted;

        let inApp = props.inApp;
        let pageId = props.pageId;

        return await authentification(appId, deviceId, login, password, eulaHaveBeenAccepted, remember_me, inApp, pageId);


    } catch (e) {
        console.log(e);

        store.dispatch(errorInitApp({info:"fetchGetAuthentication", data: e}))
    }
};

export async function authentification(appId, deviceId, login, password, eulaHaveBeenAccepted, remember_me, inApp, pageId) {

    let RoutePathArray = store.getState().routes.RoutePathArray;

    let bodyFormData = new FormData();
    bodyFormData.set("appId", appId);
    bodyFormData.set("deviceId", deviceId);
    bodyFormData.set("login", login);
    bodyFormData.set("password", password);

    if(eulaHaveBeenAccepted) {
        bodyFormData.set("eulaHaveBeenAccepted", "1");
    }

    console.log("ShapperWebRect - Try to login mobinaute :");

    return await axios({
        method: "post",
        url: baseApiUrl + Constants.WS_AUTH,
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
    })
        .then(function (response) {
            if(response.data.error_code === 1077){
                logout();
            }
            else if(response.data.success || response.data.error_code === 1078){

                pushToDataLayer({
                    event: "authentication",
                    data: {
                        eventCategory: "authentication",
                        eventAction: "authentication",
                        login: login
                    }
                });
                if (remember_me){
                    const date = new Date(Date.now());
                    date.setFullYear(date.getFullYear() + 1);
                    cookies.set("login", login, { path: "/", expires: date});
                    cookies.set("password", password, {path: "/", expires: date});
                } else {
                    cookies.set("login", login, { path: "/" });
                    cookies.set("password", password, {path: "/",});
                }







                if(response.data.error_code === 1078){
                    response.data.success = true

                    RoutePathArray['update_password'] = {
                        url: urlrewriting("update_password"),
                        title: "update_password",
                        parentId: null,
                        type: "update_password",
                        accessibility: "public"
                    }

                    if(RoutePathArray["update_password"]){
                        pushHistory(RoutePathArray["update_password"].url)
                    }
                }
                else if(inApp && pageId && RoutePathArray[pageId]){
                    pushHistory(RoutePathArray[pageId].url)
                }

                store.dispatch(resetContentData())
                store.dispatch(resetAuthenticationSsoData())
                store.dispatch(resetRouteData())
            }

            response.data.loading = false

            return response.data;
        })
        .catch(function (response) {
            //handle error
            console.log(response);

            store.dispatch(errorInitApp({info:"fetchGetAuthentication", data: response}))
        });

}

//GetAuthenticationSSO
export const fetchGetAuthenticationSSO = async (props) => {
    try {
        const state = store.getState().application;
        const RoutePathArray = store.getState().routes.RoutePathArray;

        const inApp = props.inApp;
        const pageId = props.pageId;

        const code = getQueryVariable("code");
        let access_token = cookies.get("access_token");
        let refresh_token = cookies.get("refresh_token");

        const date = new Date(Date.now());
        date.setFullYear(date.getFullYear() + 1);

        const clearAuthData = async () => {
            cookies.remove("code", { path: "/" });
            cookies.remove("access_token", { path: "/" });
            cookies.remove("refresh_token", { path: "/" });

            try {
                await localForage.clear();
                window.localStorage.clear();
            } catch (e) {
                console.log(e);
                store.dispatch(errorInitApp({ info: "localForage", data: e }));
            }

            store.dispatch(errorInitApp({ info: "localForage", data: {} }));
        };

        const authWithAccessToken = async (tokenToUse) => {
            const bodyFormData = new FormData();

            bodyFormData.set("deviceId", state.deviceId);
            bodyFormData.set("idConnectorSSO", state.id_sso ?? 0);
            bodyFormData.set("appId", state.getApp.id);

            if (code) bodyFormData.set("code", code);
            if (tokenToUse) bodyFormData.set("access_token", tokenToUse);

            return axios({
                method: "post",
                url: baseApiUrl + Constants.WS_AUTH_WITH_ACCESS_TOKEN,
                data: bodyFormData,
                headers: { "Content-Type": "multipart/form-data" },
            });
        };

        let response = await authWithAccessToken(access_token);

        if (!response.data.success && refresh_token) {
            const dataSSO = state.sso
            const new_access_token = await fetchRefreshToken(dataSSO, refresh_token);

            if (new_access_token) {
                access_token = new_access_token;
                cookies.set("access_token", access_token, { path: "/", expires: date });

                response = await authWithAccessToken(access_token);
            }
        }

        if (!response.data.success) {
            await clearAuthData();
        } else {
            if (code) {
                cookies.set("code", code, { path: "/", expires: date });
            }

            const lastItem =
                Array.isArray(response.data.result) && response.data.result.length > 1
                    ? response.data.result.at(-2)
                    : null;

            const accounts = lastItem?.mobinaute?.accounts;

            if (
                accounts &&
                accounts[state.appId_sso] &&
                (accounts[state.appId_sso].access_token || accounts[state.appId_sso].refresh_token)
            ) {
                if (accounts[state.appId_sso].access_token) {
                    cookies.set("access_token", accounts[state.appId_sso].access_token, {
                        path: "/",
                        expires: date,
                    });
                }

                if (accounts[state.appId_sso].refresh_token) {
                    cookies.set("refresh_token", accounts[state.appId_sso].refresh_token, {
                        path: "/",
                        expires: date,
                    });
                }
            }

            const redirectUrl = sessionStorage.getItem("postLoginRedirect");

            cleanUrl();

            if (redirectUrl) {
                sessionStorage.removeItem("postLoginRedirect");
                pushHistory(redirectUrl);
            } else if (inApp && pageId && RoutePathArray[pageId]) {
                pushHistory(RoutePathArray[pageId].url);
            }
        }

        store.dispatch(resetContentData());
        store.dispatch(resetAuthenticationData());
        store.dispatch(resetRouteData());

        response.data.loading = false;
        return response.data;
    } catch (e) {
        console.log("catch2", e);
        store.dispatch(errorInitApp({ info: "fetchGetAuthenticationSSO", data: e }));
        store.dispatch(errorInitApp("fetchGetAuthenticationSSO"));
    }
};

export const fetchRefreshToken = async (dataSSO, refresh_token) => {
    if (!refresh_token) {
        return null;
    }

    console.log("ShapperWebRect - Try to refresh token :");
    console.log(dataSSO);
    console.log(refresh_token);

    const redirectToSSO = () => {
        const cleanScope = (dataSSO.scope || "")
            .split("&")[0]
            .trim();

        const params = new URLSearchParams({
            response_type: "code",
            client_id: dataSSO.appId,
            state: dataSSO.state,
            nonce: crypto.randomUUID(),
            redirect_uri: dataSSO.redirect,
            scope: cleanScope,
        });

        if (dataSSO.acr_values && dataSSO.acr_values !== "null") {
            params.set("acr_values", dataSSO.acr_values);
        }

        const url_redirect =
            `${dataSSO.urlEnv}${dataSSO.endPointAuthorize}?` +
            params.toString().replace(/\+/g, "%20");

        console.log("scope brut =", dataSSO.scope);
        console.log("scope nettoyé =", cleanScope);
        console.log("ShapperWebRect - Redirect to SSO :");
        console.log(url_redirect);

        window.location.assign(url_redirect);
    };

    try {
        const data = new FormData();
        data.append("refreshToken", refresh_token);
        data.append("idConnectorSSO", dataSSO.idConnectorSSO);

        const response = await axios.post(
            baseApiUrl + Constants.WS_REFRESH_TOKEN,
            data
        );

        const respData = response.data;

        if (!respData.success || !respData.result?.access_token) {
            redirectToSSO();
            return null;
        }

        const date = new Date();
        date.setFullYear(date.getFullYear() + 1);

        cookies.set("access_token", respData.result.access_token, {
            path: "/",
            expires: date,
        });

        if (respData.result.refresh_token) {
            cookies.set("refresh_token", respData.result.refresh_token, {
                path: "/",
                expires: date,
            });
        }

        return respData.result.access_token;
    } catch (e) {
        console.log("fetchRefreshToken error", e);
        redirectToSSO();
        return null;
    }
};
